export const APP_NAME = 'Banana-mod';
